import React from 'react';
import { useUI } from '../../context/UIContext';
import Navigation from './Navigation';

const Header = () => {
  const { isHeaderCompact, mobileMenuOpen, toggleMobileMenu } = useUI();

  return (
    <header className={`site-header ${isHeaderCompact ? 'compact' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <a href="#home" aria-label="J&C Renovations Home">
              <h1>J&C Renovations</h1>
              {/* Logo image can be added here */}
            </a>
          </div>

          <button 
            className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <Navigation />
        </div>
      </div>
    </header>
  );
};

export default Header;
